/**
 * Timezone options for the branding settings form.
 *
 * Currency, locale, and the logo/favicon size/type limits used to be
 * hand-copied here from the server's own curated lists
 * (`competition_insights.modules.tenancy.settings.constants`) — two independently
 * maintained copies of the same vocabulary that could silently drift apart.
 * They are now served by `GET /tenancy/settings/branding/options`
 * (`useBrandingOptions` in `useBrandingSettings.ts`) instead, so there is one
 * source of truth. Timezones stay local: they come from the browser's own
 * IANA database (`Intl.supportedValuesOf`), not a server-curated list, so
 * there is nothing to drift.
 */

const FALLBACK_TIMEZONES: readonly string[] = [
  'Europe/London',
  'Europe/Dublin',
  'Europe/Paris',
  'Europe/Berlin',
  'America/New_York',
  'America/Los_Angeles',
  'America/Toronto',
  'Australia/Sydney',
  'Pacific/Auckland',
  'UTC',
]

export function timezoneOptions(): readonly string[] {
  const supported = (Intl as { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf
  if (!supported) return FALLBACK_TIMEZONES
  try {
    return supported('timeZone')
  } catch {
    return FALLBACK_TIMEZONES
  }
}
